import styled from 'styled-components';
import { rgba } from 'polished';
import React from 'react';
import { combineValues, globalTheme } from '@clds/component-theme';
import { Draggable } from '@clds/icon';
import focusCss from '../../helpers/focusCss';
import TrimTrack from './TrimTrack';

const TrimDragChildren = styled(Draggable).attrs({ size: 'md' })`
  position: relative;
  z-index: 1;
  transform: rotate(90deg);
`;

const TrimDrag = styled(TrimTrack).attrs(() => ({ tabIndex: 0, assignFocusToAfter: true, children: <TrimDragChildren size="md" /> }))`
  outline: none;
  z-index: 1;
  cursor: grab;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${combineValues(globalTheme.palette.contrastInvert, (color) => rgba(color, 0.5))};

  ${focusCss};

  :after {
    left: 0;
    right: 0;
    border-radius: 100px;
  }
`;

export default TrimDrag;
